import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';
import moment from 'moment';

Vue.use(Vuex);
Vue.use(VueCookies)

export default new Vuex.Store({
  state: {
    user: {
      username: window.$cookies.get("crt_username") || "",
      roles: window.$cookies.get("crt_userRoles") || []
    },
    token: window.$cookies.get("crt_token") || "",
    expires: window.$cookies.get("crt_expires") || "",
    dealName: "",
    lastAcisDeal: "",
    lastCirtDeal: "",
    lastBondDeal: "",
    bondName: "",
    dealCashflow: {
      collateralCashflow: [],
      bondCashflows: [],
      collateralInfo: {},
      bondsInfo: {}
    },
    acisSingleResult: {
      yield: "",
      wal: "",
      principalWindow: "",
      writedownPct: "",
      firstLossPeriod: "",
      acisCashflow: [],
      lineMetrics: {}
    },
    acisMatrixResult: {
      roiMatrix: [[]],
      rateOnLineMatrix: [[]],
      lossOnLineMatrix: [[]],
      returnOnLineMatrix: [[]]
    },
    portfolioName: "",
    portfolioResult: {
      portfolioEntries: [],
      totals: {
        ownedFaceAmt: "",
        acisYield: "",
        acisRol: "",
        acisLol: "",
        acisRetol: "",
        cirtYield: "",
        cirtRol: "",
        cirtLol: "",
        cirtRetol: ""
      },
      acisPortfolioCashflow: [],
      cirtPortfolioCirtCashflow: [],
      bondsPortfolioCirtCashflow: [],
      cirtTotals: {},
      acisTotals: {},
      bondsTotals: {},
      interestRate: 0
    },
    cirtSingleResult: {
      yield: "",
      wal: "",
      lossWindow: "",
      writedownPct: "",
      firstLossPeriod: "",
      cirtCashflow: [],
      lineMetrics: {},
      policyInformation: {}
    },
    cirtMatrixResult: {
      yieldMatrix: [[]],
      rateOnLineMatrix: [[]],
      lossOnLineMatrix: [[]],
      returnOnLineMatrix: [[]]
    },
    useAdco: false,
    useLoanLevel: false,
    prepaymentModel: null,
    cleanupCall: false
  },
  mutations: {
    login(state, data) {
      state.expires = moment().add(data["expires_in"], 'seconds');
      state.token = data.access_token;
      state.user.username = data.username;
      state.user.roles = JSON.parse(data.roles);
      window.$cookies.set("crt_expires", JSON.stringify(state.expires), data["expires_in"] + "s");
      window.$cookies.set("crt_token", state.token, data["expires_in"] + "s");
      window.$cookies.set("crt_username", state.user.username, data["expires_in"] + "s");
      window.$cookies.set("crt_userRoles", JSON.stringify(state.user.roles), data["expires_in"] + "s");
    },
    logout(state) {
      window.$cookies.remove(window.API_BASE_URL);
      for (let key of window.$cookies.keys()) {
        window.$cookies.remove(key);
      }
      state.expires = "";
      state.token = "";
      state.user.username = '';
      state.user.roles = [];
      state.useAdco = false;
      state.prepaymentModel = null;
      state.useLoanLevel = false;
    },
    setDealName(state, data) {
      if (state.dealName != data) {
        state.dealName = data;
        state.dealCashflow = {
          collateralCashflow: [],
          bondCashflows: [],
          collateralInfo: {},
          bondsInfo: {}
        }
      }
    },
    setBondName(state, data) {
      state.bondName = data;
    },
    saveDealCashflow(state, data) {
      state.dealCashflow = {
        collateralCashflow: data.collateralCashflow,
        bondsCashflows: data.bondsCashflows,
        collateralInfo: data.collateralInfo,
        bondsInfo: data.bondsInfo
      }
    },
    saveAcisSingleResult(state, data) {
      state.acisSingleResult = {
        yield: data.Yield,
        wal: data.Wal,
        principalWindow: data.PrincipalWindow,
        writedownPct: data.WritedownPct,
        firstLossPeriod: data.FirstLossPeriod,
        acisCashflowTotals: data.AcisCashflowTotals,
        acisCashflow: data.AcisCashflow,
        lineMetrics: data.LineMetrics
      }
    },
    saveAcisMatrixResult(state, data) {
      state.acisMatrixResult = {
        roiMatrix: data.RoiMatrix,
        rateOnLineMatrix: data.RateOnLineMatrix,
        lossOnLineMatrix: data.LossOnLineMatrix,
        returnOnLineMatrix: data.ReturnOnLineMatrix
      }
    },
    changePortfolioName(state, data) {
      state.portfolioName = data;
      state.portfolioResult = {
        totals: {
          ownedFaceAmt: "",
          yield: "",
          writedownPct: "",
          firstLossPeriod: ""
        },
        portfolioCashflow: [],
        cashflowTotals: {},
        portfolioEntries: []
      }
    },
    savePortfolioResult(state, data) {
      state.portfolioResult = {
        portfolioEntries: data.portfolioEntries,
        totals: {
          ownedFaceAmt: data.totals.OwnedFaceAmt,
          acisYield: data.totals.AcisYield,
          acisRol: data.totals.AcisRol,
          acisLol: data.totals.AcisLol,
          acisRetol: data.totals.AcisRetol,
          cirtYield: data.totals.CirtYield,
          cirtRol: data.totals.CirtRol,
          cirtLol: data.totals.CirtLol,
          cirtRetol: data.totals.CirtRetol
        },
        acisPortfolioCashflow: data.acisPortfolioCashflow,
        cirtPortfolioContractCashflow: data.cirtPortfolioCashflow,
        bondsPortfolioContractCashflow: data.bondsPortfolioCashflow,
        cirtTotals: data.cirtTotals,
        acisTotals: data.acisTotals,
        bondsTotals: data.bondsTotals,
        interestRate: data.interestRate
      }
    },
    saveCirtSingleResult(state, data) {
      state.cirtSingleResult = {
        yield: data.Yield,
        wal: data.Wal,
        lossWindow: data.LossWindow,
        writedownPct: data.WritedownPct,
        firstLossPeriod: data.FirstLossPeriod,
        cirtCashflow: data.cirtCashflow,
        lineMetrics: data.LineMetrics,
        policyInformation: data.PolicyInformation
      }
    },
    saveCirtMatrixResult(state, data) {
      state.cirtMatrixResult = {
        yieldMatrix: data.YieldMatrix,
        rateOnLineMatrix: data.RateOnLineMatrix,
        lossOnLineMatrix: data.LossOnLineMatrix,
        returnOnLineMatrix: data.ReturnOnLineMatrix
      }
    },
    useAdcoChanged(state, data) {
      state.useAdco = data;
    },
    prepaymentModelChanged(state, data) {
      state.prepaymentModel = data;
    },
    useLoanLevelChanged(state, data) {
      state.useLoanLevel = data;
    },
    useCleanupCall(state, data) {
      state.cleanupCall = data;
    },
    setLastDeal(state, data) {
      if (data.startsWith("ACIS")) { state.lastAcisDeal = data; } else if (data.startsWith("CIRT")) { state.lastCirtDeal = data; } else { state.lastBondDeal = data; }
    }
  },
  getters: {
    expires: state => state.expires,
    token: state => state.token,
    authenticated: state => state.token != "",
    username: state => state.user.username,
    hasRole: (state) => (role) => state.user.roles.includes(role),
    isOnlineDealsCreationAllowed: (state, getters) => {
      // On a call on March 15 there were doubts that Admin should has this functionality by default
      return /*getters.hasRole('Admin') ||*/ getters.hasRole('OnlineDeals_Creator');
    },
    isAdmin: state => state.user.roles.includes("Admin"),
    isDocReader: state => state.user.roles.includes("DocReader"),
    isLDMUser: state => state.user.roles.includes("LDM_User"),
    isAFTUser: state => state.user.roles.includes("AFT_User"),
    isCollateralUser: state => state.user.roles.includes("Collateral_User"),
    dealName: state => state.dealName,
    bondName: state => state.bondName,
    dealCashflow: state => state.dealCashflow,
    acisSingleResult: state => state.acisSingleResult,
    acisMatrixResult: state => state.acisMatrixResult,
    portfolioName: state => state.portfolioName,
    portfolioResult: state => state.portfolioResult,
    cirtSingleResult: state => state.cirtSingleResult,
    cirtMatrixResult: state => state.cirtMatrixResult,
    useAdco: state => state.useAdco,
    prepaymentModel: state => state.prepaymentModel,
    useLoanLevel: state => state.useLoanLevel,
    cleanupCall: state => state.cleanupCall,
    lastAcisDeal: state => state.lastAcisDeal,
    lastCirtDeal: state => state.lastCirtDeal,
    lastBondDeal: state => state.lastBondDeal
  }
})
